import {Vector3, SphereGeometry, Mesh, Color, AdditiveBlending, AlwaysDepth, ShaderMaterial, DoubleSide} from 'three'

import { attrOort } from '../configEntities/groupsAttr.js'

import { colorSizeAleat } from '../groupsEntities/galaxy.js'
import { pushShift } from '../groupsEntities/entitiesGroups.js'

import { Object } from '../groupsEntities/entitiesGroups.js'
import fragmentAround from '../../../shaders/atmAround/fragmentOort.glsl';
import vertexAround from '../../../shaders/atmAround/vertexOort.glsl';
import meteourTexture from '../../../assets/textures/asteroids/asteroid.png'
import {sceneManager } from '../script.js'
import { animateParts } from '../utils/many-bodies.js'

export class CloudOort {
  constructor(centerElement) {
    this.posInt = []
    this.posCut = []
    this.R = 23.47116 * 200000 
    this.name = 'Oort Cloud'
    this.distCam = this.R * 100
    this.qtd = 5000
    this.meteourTexture = meteourTexture
    this.blending = AlwaysDepth

    this.maxSpeed = 4.5e-6
    this.minSpeed = 2.2e-6
    this.inclSpeed = 8e-11
    this.speeds = []
    this.parameters = this.generateAttr(this.qtd)
 
    this.centerElement = centerElement

    this.element = new Object(
      this.name,
      this.distCam,
      this.labelPosition(),
      this.parameters,
      this.blending,
      this.meteourTexture,
    )
    sceneManager.commands.addParticlesHighlight(3e9, this.element)
    this.createBright()
  }
  createBright(){
    this.matAround = new ShaderMaterial({
      uniforms: {
        color2:    { value: new Color(0x000000) }, 
        color1:    { value: new Color(0xADD8E6) },
        edgeStart: { value: 0.1 }, 
        edgeEnd:   { value: 1.0 }
      },
      vertexShader:   vertexAround,
      fragmentShader: fragmentAround,
      blending:       AdditiveBlending,
      depthTest:      true,
      depthWrite:     false,
      transparent:    false,
      side:           DoubleSide,
    });
        
        this.geoAround = new SphereGeometry(this.R*1.02, 64, 64);
        this.meshAround = new Mesh(this.geoAround, this.matAround);

        this.meshAround.material.opacity = 0.1
        this.meshAround.position.set(0,0,0)
        sceneManager.scene.add(this.meshAround);
  }


  generateAttr(numPoints) {
    let coord = []
    let colors = []
    let sizes = []
    let randValue = []


    let shift = [];

    this.posCut.length = 0

    for (let i = 0; i < numPoints; i++) {
      const theta = Math.random() * Math.PI * 2
      const phi = Math.acos(2 * (Math.pow(Math.random(),1.5)) - 1) / 1.75

      const raio = Math.cbrt(Math.random()) * this.R
      const x = raio * Math.cos(theta) * Math.sin(phi)
      const z = raio * Math.sin(phi) * Math.sin(theta)
      const y = raio * Math.cos(phi)
      const y2 = -raio * Math.cos(phi)
      
      const distance = Math.sqrt(x * x + y * y + z * z)

      let aleat = colorSizeAleat(attrOort)
        colors.push(aleat.color)
        sizes.push(aleat.size)

        const randomSpeed = Math.random() * (this.maxSpeed - this.minSpeed) + this.minSpeed

        this.speeds.push(randomSpeed)

      if (
        (!inEllipsoid(x, y, z, phi, this.R) ||
          !isInCenter(x, y, z, phi, this.R)) &&
        distance > this.R * 0.02
      ) {
        
        coord.push(new Vector3(x, y, z))
        coord.push(new Vector3(x, y2, z))
        pushShift(shift, 100000);
        randValue.push(Math.random() * 10.0*i)
      }     
    }
    return { coord, colors, sizes,shift, randValue}
  }

  labelPosition() {
    const position = new Vector3(0, this.R, 0)

    return position
  }
  centerOrbit() {
    this.element.objects.position.copy(this.centerElement.mesh.position)
  }

  animate(speed) {
    if (!this.element.objects) return;
    let distSun = sceneManager.camera.position.distanceTo(this.centerElement.mesh.position);
    this.centerOrbit()
    animateParts(
      this.element.objects,
      speed,
      this.speeds,
    );
    
    this.element.setLabelVisible(this.centerElement.mesh.position, sceneManager.camera, sceneManager.commands.controls.labels)
    this.element.pointMaterial.uniforms.time.value += speed*this.inclSpeed

    this.element.pointMaterial.uniforms.opacity.value = Math.max(0.1, Math.min(1, distSun / this.R));
    }
}

function inEllipsoid(x, y, z, phi, radiusOort) {
  const dx = x / (2 * Math.acos(phi * 0.5) * radiusOort * 0.45)
  const dy = y / (radiusOort * 0.85)
  const dz = z / (2 * Math.acos(phi * 0.5) * radiusOort * 0.45)
  return dx * dx + dy * dy + dz * dz <= 1
}

function isInCenter(x, y, z, phi, radiusOort) {
  const dx = x / (2 * Math.acos(phi * 0.5) * radiusOort * 0.9)
  const dz = z / (2 * Math.acos(phi * 0.5) * radiusOort * 0.9)
  const isInsideSector =
    dx * dx + dz * dz <= 100 &&
    (y >= 50 ? (y * y) / (radiusOort * radiusOort) <= 100 : false)
  return isInsideSector
}
